import React from "react";

function SofortIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      height="24"
      width="24"
      viewBox="0 0 24 24"
      xmlSpace="preserve"
    >
      <path
        fill="none"
        fillRule="evenodd"
        stroke="#303C42"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit="10"
        d="M22 20.5H2A1.5 1.5 0 01.5 19V5A1.5 1.5 0 012 3.5h20A1.5 1.5 0 0123.5 5v14a1.5 1.5 0 01-1.5 1.5z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#303C42"
        d="M8.612 10.433a1.84 1.84 0 00-.788.18c-.356.17-.679.45-.943.823a3.57 3.57 0 00-.432.837c-.216.593-.214 1.073.007 1.39.126.18.386.393.916.394h.002c.966 0 1.687-.633 2.143-1.882.12-.33.28-.946-.01-1.362-.176-.252-.477-.38-.895-.38zm5.826 0a1.84 1.84 0 00-.788.18c-.356.17-.679.45-.942.823a3.563 3.563 0 00-.433.837c-.216.593-.214 1.073.008 1.39.125.18.386.393.916.394h.002c.966 0 1.686-.633 2.143-1.882.12-.33.28-.946-.011-1.362-.176-.252-.477-.38-.895-.38zm-8.927.05c-.318 0-.627 0-.903.14-.277.141-.52.422-.709.984-.04.12-.062.225-.065.315a.471.471 0 00.047.235c.043.081.111.158.197.223a.966.966 0 00.3.151l.132.038.204.06c.03.01.064.021.094.04.03.018.058.042.075.075a.167.167 0 01.018.073.237.237 0 01-.014.084.23.23 0 01-.14.156c-.074.03-.183.04-.35.04H2.325l-.328.901h2.22c.209 0 .59 0 .958-.156.367-.156.719-.467.868-1.09.056-.235.038-.426-.053-.576-.092-.15-.259-.259-.502-.328l-.118-.034-.174-.05a.234.234 0 01-.138-.1.196.196 0 01-.021-.158.23.23 0 01.115-.138.466.466 0 01.225-.05h1.29c.01-.013.018-.027.027-.04a2.85 2.85 0 01.833-.794H5.511zm5.8 0c-.574 0-1.002.291-1.204.835l-.975 2.68H10.2l.502-1.378.944.001.269-.738h-.941l.151-.428a.225.225 0 01.218-.137h1.113c.01-.013.018-.027.027-.04.236-.334.57-.604.882-.794H11.31zm4.957.003L14.988 14h1.088l.465-1.237c.023.051.297 1.237.297 1.237h1.143s-.208-.871-.36-1.223c-.04-.09-.081-.192-.136-.277.323-.12.79-.378.984-.9.12-.32.113-.58-.02-.77-.16-.23-.486-.344-.997-.344h-1.184zm2.23 0a.878.878 0 01.177.187.914.914 0 01.146.647h.648l-.976 2.681h.975l.976-2.68h1.252l.304-.835h-3.502zm-1.513.725h.18c.327 0 .45.096.338.396-.104.28-.291.455-.648.455h-.186l.316-.85zm-8.63.018c.334 0 .41.194.118.996-.302.824-.52 1.032-.85 1.032-.32 0-.433-.203-.133-1.024.224-.613.514-1.004.865-1.004zm5.827 0c.334 0 .41.194.117.996-.301.824-.52 1.032-.849 1.032-.321 0-.433-.203-.133-1.024.223-.613.514-1.004.865-1.004z"
      ></path>
    </svg>
  );
}

export default SofortIcon;
